(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-context.js') >= 0) return;  svs.modules.push('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-context.js');
"use strict";

const {
  createContext
} = React;
const ReactIntersectionContext = createContext();
setGlobal('svs.components.lbUtils.intersectionObserver.ReactIntersectionContext', ReactIntersectionContext);

 })(window);